const getDealershipDepartment = (dealershipItem) => {
  var _a;
  if (!((_a = dealershipItem.data.departments) == null ? void 0 : _a.length)) {
    return;
  }
  return dealershipItem.data.departments.find(({ apps }) => !!apps && (apps == null ? void 0 : apps.includes("instock")));
};
export {
  getDealershipDepartment
};
